import adserver, { AxiosError } from 'services/adserver';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { monitoringKeys } from './monitoring.keys';
import { MonitoringProposalCodes } from './monitoring.types';

const getProposalCodes = async (
  proposalId: number,
): Promise<MonitoringProposalCodes> => {
  const { data } = await adserver({
    url: `/proposal/${proposalId}/monitoring/codes`,
    headers: {},
  });

  return data;
};

export const useGetProposalCodes = (
  proposalId: number,
  enabled = true,
): UseQueryResult<MonitoringProposalCodes, AxiosError> => {
  return useQuery<MonitoringProposalCodes, AxiosError>({
    queryKey: monitoringKeys.proposalCodes(proposalId),
    queryFn: () => getProposalCodes(proposalId),
    enabled: !!proposalId && enabled,
  });
};
